// src/pages/PartnerStripeSuccess.tsx
'use client';
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function PartnerStripeSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      navigate("/partner/stripe-connect");
      return;
    }

    // Exchange code for Stripe account ID
    fetch("https://connect.stripe.com/oauth/token", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        client_secret: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY, // ← put in .env
        code,
        grant_type: "authorization_code",
      }),
    })
      .then(r => r.json())
      .then(async (data) => {
        if (data.error) throw new Error(data.error_description);

        const { data: { user } } = await supabase.auth.getUser();
        await supabase
          .from("partner_accounts")
          .update({ stripe_account_id: data.stripe_user_id })
          .eq("user_id", user.id);

        navigate("/partner/dashboard", { replace: true });
      })
      .catch(() => navigate("/partner/stripe-connect"));
  }, [searchParams, navigate]);

  return <div className="min-h-screen bg-[#ffffff] text-[#0f172a] text-2xl">Finishing setup...</div>;
}
